export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "legDownload.worker.8232f4469e0ee78d0b73-423.worker.js");
}
